import React from "react";
import { TiPlus } from "react-icons/ti";

const CrossIconForUploader = ({ onClick }: { onClick: (e: React.MouseEvent<SVGElement>) => void | (() => void) }) => {
  return (
    <>
      <div className="absolute -right-2.5 -top-2.5 h-[24px] w-[24px] cursor-pointer rounded-full bg-gray"></div>
      <TiPlus fill="#ffffff" className="absolute -right-[5px] -top-[5px] rotate-45 " onClick={onClick} size={14} />
    </>
  );
};

export default CrossIconForUploader;
